import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function NonEmergency() {
  const navigate = useNavigate();
  const [showHospitalBg, setShowHospitalBg] = useState(false); // state to toggle background

  return (
    <div>
      {/* Background Video (visible only when hospital bg is false) */}
      {!showHospitalBg && (
        <video autoPlay loop muted style={styles.backgroundVideo}>
          <source src="/video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      {/* Hospital Background Image (visible only after button click) */}
      {showHospitalBg && <div style={styles.background}></div>}

      {/* Ambulance image - always above background */}
      {showHospitalBg && (
        <div style={styles.ambulanceContainer}>
          <img
            src="/ambulancesp.jpg"
            alt="Ambulance"
            style={styles.ambulance}
          />
        </div>
      )}

      {/* Button to navigate to the nearest hospital locator */}
      <button
        onClick={() => {
          setShowHospitalBg(true); // show hospital background
          navigate("/nearest-hospital");
        }}
        style={{ ...styles.button, top: "50%" }}
      >
        🚑 Find Nearest Hospital
      </button>

      {/* ✅ Updated Button to open indexw.html from public folder */}
      <button
        onClick={() => window.open("/indexw.html", "_blank")}
        style={{ ...styles.button, top: "70%", backgroundColor: "#8B0000" }}
      >
        🗺️ Open Map
      </button>
    </div>
  );
}

// Styles
const styles = {
  backgroundVideo: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 0,
    filter: "blur(3px)",
  },
  background: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url("/526f3b3f-711f-4165-8566-8c0943242994.png")`, // 👈 hospital bg
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    zIndex: 0,
  },
  button: {
    position: "fixed",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px 40px",
    fontSize: "24px",
    fontWeight: "bold",
    backgroundColor: "#D2B48C",
    color: "white",
    border: "2px solid white",
    outline: "none",
    cursor: "pointer",
    borderRadius: "12px",
    transition: "all 0.3s ease",
    boxShadow: "0px 4px 15px rgba(210, 180, 140, 0.5)",
    zIndex: 2,
  },
  ambulanceContainer: {
    position: "absolute",
    bottom: "10%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1,
  },
  ambulance: {
    width: "200px",
    height: "auto",
  },
};

export default NonEmergency;
